<template>
  <div class="caring-itemTable">
    <Table :data="dataSource" :columns="columns"></Table>
  </div>
</template>
<script>
export default {
  props: {
    dataSource: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {};
  },
  mounted() {
  }
};
</script>
<style lang="less">
.caring-itemTable {
  .ivu-table-wrapper{
    border: none;
  }
  .ivu-table::before, .ivu-table::after {
    height: 0;
  }
  .ivu-table {
    th {
      background: #fff;
      color: #c2ccdb;
      border: none;
    }
  }
  .ivu-table td, .ivu-table th {
    border: none;
  }
}
</style>
